import { connect } from 'react-redux'

import RegisterWidgetSection from 'components/home-page/views/sections/register-widget'

const mapStateToProps = (state, ownProps) => ({
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(RegisterWidgetSection)
